<template>
  <div class="treeCom">
    <el-input
      :placeholder="placeholder"
      v-model="filterText"
      clearable
      class="mb-[5px]"
    >
    </el-input>
    <el-tree
      ref="tree"
      node-key="id"
      :data="data"
      :default-expand-all="isAllExpand"
      :default-expanded-keys="defaultExpandedKeys"
      :default-checked-keys="defaultCheckedKeys"
      :props="defaultProps"
      :expand-on-click-node="false"
      :show-checkbox="showCheckbox"
      :check-strictly="checkStrictly"
      :filter-node-method="filterNode"
      @node-click="handleNodeClick"
      @check="handleCheckChange"
      highlight-current
    >
      <template slot-scope="{ node }">
        <span v-if="node.label.length <= 5" class="treeLabel">
          {{ node.label }}</span
        >
        <el-tooltip
          effect="dark"
          placement="top-start"
          :content="node.label"
          v-else
        >
          <span class="treeLabel"> {{ node.label }}</span>
        </el-tooltip>
      </template>
    </el-tree>
  </div>
</template>

<script>
export default {
  name: "Tree",
  props: {
    placeholder: {
      default: "请输入搜索关键字",
    },
    data: {
      type: Array,
      default: () => {
        return [];
      },
    },
    isAllExpand: {
      type: Boolean,
      default: false,
    },
    // 默认展开的层级
    defaultExpandedKeys: {
      type: Array,
      default: () => {
        return [];
      },
    },
    defaultCheckedKeys: {
      type: Array,
      default: () => {
        return [];
      },
    },
    defaultProps: {
      type: Object,
      default: () => {
        return {
          children: "children",
          label: "name",
        };
      },
    },
    showCheckbox: {
      type: Boolean,
      default: false,
    },
    // 是否严格遵循父子不关联
    checkStrictly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      filterText: "",
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },

  methods: {
    handleNodeClick(val) {
      this.$emit("handleNodeClick", val);
    },
    handleCheckChange() {
      this.$emit("handleCheckChange", this.$refs.tree.getCheckedNodes());
    },
    filterNode(value, data) {
      if (!value) return true;
      if (data.name) {
        return data.name.indexOf(value) !== -1;
      }
    },
  },
};
</script>

<style lang="scss">
.treeCom {
  height: 100%;
  .treeLabel {
    font-size: 14px !important;
    color: #333;
  }
  .el-tree {
    height: calc(100% - 38px) !important;
    padding-right: 10px;
    overflow: overlay;
    .el-tree-node__content {
      width: 155px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      display: block;
    }
    ::-webkit-scrollbar {
      width: 10px;
      height: 10px;
    }

    ::-webkit-scrollbar-thumb {
      padding-left: 10px;
      background-color: #999;
      border-radius: 8px;
    }
  }
}
</style>
